import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b7a8896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "groupInputs flex" }
const _hoisted_2 = { class: "inputRow" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = { class: "flex detailRow" }
const _hoisted_6 = { class: "detailAttribute" }
const _hoisted_7 = { class: "flex detailRow" }
const _hoisted_8 = { class: "detailAttribute" }
const _hoisted_9 = { class: "flex detailRow" }
const _hoisted_10 = { class: "detailAttribute" }
const _hoisted_11 = { class: "flex detailRow" }
const _hoisted_12 = { class: "detailAttribute" }
const _hoisted_13 = { class: "flex detailRow" }
const _hoisted_14 = { class: "detailAttribute" }
const _hoisted_15 = { class: "flex detailRow" }
const _hoisted_16 = { class: "detailAttribute" }
const _hoisted_17 = { class: "flex detailRow" }
const _hoisted_18 = { class: "detailAttribute" }
const _hoisted_19 = { class: "flex detailRow" }
const _hoisted_20 = { class: "detailAttribute" }
const _hoisted_21 = { class: "flex detailRow" }
const _hoisted_22 = { class: "detailAttribute" }
const _hoisted_23 = { class: "flex detailRow" }
const _hoisted_24 = { class: "detailAttribute" }
const _hoisted_25 = { class: "groupInputs flex" }
const _hoisted_26 = { class: "inputRow" }
const _hoisted_27 = { class: "inputTitle" }
const _hoisted_28 = { class: "inputField flex-grow" }
const _hoisted_29 = { class: "flex detailRow" }
const _hoisted_30 = { class: "detailAttribute" }
const _hoisted_31 = { class: "flex detailRow" }
const _hoisted_32 = { class: "detailAttribute" }
const _hoisted_33 = { class: "flex detailRow" }
const _hoisted_34 = { class: "detailAttribute" }
const _hoisted_35 = { class: "flex detailRow" }
const _hoisted_36 = { class: "detailAttribute" }
const _hoisted_37 = { class: "flex detailRow" }
const _hoisted_38 = { class: "detailAttribute" }
const _hoisted_39 = { class: "groupInputs flex" }
const _hoisted_40 = { class: "inputRow" }
const _hoisted_41 = { class: "inputTitle" }
const _hoisted_42 = { class: "inputField flex-grow" }
const _hoisted_43 = { class: "flex detailRow" }
const _hoisted_44 = { class: "detailAttribute" }
const _hoisted_45 = { class: "flex detailRow" }
const _hoisted_46 = { class: "detailAttribute" }
const _hoisted_47 = { class: "flex detailRow" }
const _hoisted_48 = { class: "detailAttribute" }
const _hoisted_49 = { class: "flex detailRow" }
const _hoisted_50 = { class: "detailAttribute" }
const _hoisted_51 = { class: "groupInputs flex mt-[2rem]" }
const _hoisted_52 = { class: "inputRow" }
const _hoisted_53 = { class: "inputTitle" }
const _hoisted_54 = { class: "inputField flex-grow" }
const _hoisted_55 = { class: "flex detailRow" }
const _hoisted_56 = { class: "detailAttribute" }
const _hoisted_57 = { class: "flex detailRow" }
const _hoisted_58 = { class: "detailAttribute" }
const _hoisted_59 = { class: "flex detailRow" }
const _hoisted_60 = { class: "detailAttribute" }
const _hoisted_61 = { class: "flex detailRow" }
const _hoisted_62 = { class: "detailAttribute" }
const _hoisted_63 = { class: "groupInputs flex" }
const _hoisted_64 = { class: "inputRow" }
const _hoisted_65 = { class: "inputTitle" }
const _hoisted_66 = { class: "inputField flex-grow mb-[9rem]" }
const _hoisted_67 = { class: "error-msg" }

import {onMounted, ref, toRef, computed} from "vue";
import {useSystemStore} from "@/stores/system/SystemStore";
import Select from "@/components/system/inputs/Select.vue";
import {UserService} from "@/utilities/services/entities/UserService";
import {Form} from "@/models/entities/forms/Form";
import {ErrorLocationType} from "@/utilities/system/enums/Enums";
import {User} from "@/models/entities/users/User";
import {PlantService} from "@/utilities/services/entities/PlantService";
import {Plant} from "@/models/entities/plants/Plant";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import {useI18n} from "vue-i18n";
import DateToStringHelper from "@/utilities/system/helpers/DateToStringHelper";



export default /*#__PURE__*/_defineComponent({
  __name: 'FormReportChangeOwnerPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const props = __props
const popupData = toRef(props, 'data');
const currentForm = ref<Form>(popupData.value as Form)

const systemStore = useSystemStore();
const userService = new UserService();
const plantService = new PlantService();

const creatorDetails = ref<User|null>(null);
const ownerDetails = ref<User|null>(null);
const userList = ref<Array<any>|null>(null);
const plantDetails = ref<Plant|null>(null);


const changeOwnerForCurrentForEntry = (userId:string)=>{
  const newOwnerUser = userList.value?.find(u => u.id === userId);
  (popupData.value as Form).ownerId = userId;
  (popupData.value as Form).ownerName = `${newOwnerUser?.firstName} ${newOwnerUser?.lastName}`;
}

const rules = computed(() => {
  return {
    ownerId: { required: helpers.withMessage(t('validators.required'), required) },
  }
})
//@ts-expect-error
const v$ = ref(useVuelidate(rules, popupData));

const getFilteredUserList = async ():Promise<Array<User>|null> =>{
  const rawUsers = await userService.getUsers(ErrorLocationType.popup);
  if(!rawUsers) return null;
  return rawUsers.filter(u => u.roles.includes("PlantManager"))
}

onMounted(async ()=>{
  //@ts-expect-error
  systemStore.modal.validator = v$;

  creatorDetails.value = await userService.getUserById((popupData.value as Form).creatorId, ErrorLocationType.popup)
  if(!creatorDetails.value)return

  ownerDetails.value = (popupData.value as Form).ownerId //TODO check only needed until old forms are gone!
      ? await userService.getUserById((popupData.value as Form).ownerId, ErrorLocationType.popup)
      : null;
  if((popupData.value as Form).ownerId && !ownerDetails.value)return

  const resp = await getFilteredUserList();
  if(!resp)return
  userList.value = resp
    .sort((a, b) => a.lastName.localeCompare(b.lastName))
    .map(u => {
      //@ts-expect-error
      u.fullName = `${u?.firstName} ${u?.lastName}`;
      return u;
    })

  // BTBs are not linked to locations therefore avoid calling failing API
  if(popupData.value!.name === 'BTB')return

  plantDetails.value = await plantService.getPlantById((popupData.value as Form).locationId?.toString(), ErrorLocationType.popup);
  if(!plantDetails.value)return
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('formReports.popups.owner.formDetails')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('formReports.grid.id')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.id), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('formReports.grid.createdAt')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.createdAt ? _unref(DateToStringHelper)(new Date (currentForm.value.createdAt)) : ""), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('formReports.grid.creatorName')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.creatorName), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('formReports.grid.locationName')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.locationName), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('formReports.grid.facilityName')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.facilityName), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('formReports.grid.activityName')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.activityName), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('formReports.grid.categoryName')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.categoryName), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('formReports.grid.description')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.description), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('formReports.grid.changedAt')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.changedAt ? _unref(DateToStringHelper)(new Date (currentForm.value.changedAt)) : ""), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('formReports.grid.finishedAt')), 1),
            _createElementVNode("div", null, _toDisplayString(currentForm.value.finishedAt ? _unref(DateToStringHelper)(new Date (currentForm.value.finishedAt)) : ""), 1)
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('formReports.popups.owner.plantDetails')), 1),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('plantManagment.grid.name')), 1),
            _createElementVNode("div", null, _toDisplayString(plantDetails.value?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('plantManagment.grid.phoneNumber')), 1),
            _createElementVNode("div", null, _toDisplayString(plantDetails.value?.phoneNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('plantManagment.grid.email')), 1),
            _createElementVNode("div", null, _toDisplayString(plantDetails.value?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)('plantManagment.grid.street')), 1),
            _createElementVNode("div", null, _toDisplayString(plantDetails.value?.street) + " " + _toDisplayString(plantDetails.value?.houseNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('plantManagment.grid.postalcode')), 1),
            _createElementVNode("div", null, _toDisplayString(plantDetails.value?.postalcode) + " " + _toDisplayString(plantDetails.value?.city), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, popupData.value.name !== 'BTB']
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('formReports.popups.owner.creatorDetails')), 1),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('userManagment.grid.firstName')), 1),
            _createElementVNode("div", null, _toDisplayString(creatorDetails.value?.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('userManagment.grid.lastName')), 1),
            _createElementVNode("div", null, _toDisplayString(creatorDetails.value?.lastName), 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(t)('userManagment.grid.email')), 1),
            _createElementVNode("div", null, _toDisplayString(creatorDetails.value?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(t)('userManagment.grid.phone')), 1),
            _createElementVNode("div", null, _toDisplayString(creatorDetails.value?.dialCode) + _toDisplayString(creatorDetails.value?.phoneNumber), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('formReports.popups.owner.ownerDetails')), 1),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(t)('userManagment.grid.firstName')), 1),
            _createElementVNode("div", null, _toDisplayString(ownerDetails.value?.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(t)('userManagment.grid.lastName')), 1),
            _createElementVNode("div", null, _toDisplayString(ownerDetails.value?.lastName), 1)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(t)('userManagment.grid.email')), 1),
            _createElementVNode("div", null, _toDisplayString(ownerDetails.value?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(t)('userManagment.grid.phone')), 1),
            _createElementVNode("div", null, _toDisplayString(ownerDetails.value?.dialCode) + _toDisplayString(ownerDetails.value?.phoneNumber), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('formReports.popups.owner.selectOwner')), 1),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.ownerId.$errors.length })
          }, [
            _createVNode(Select, {
              searchable: true,
              selected: currentForm.value.ownerId,
              label: "fullName",
              options: userList.value,
              mode: "single",
              onSelectChanged: changeOwnerForCurrentForEntry
            }, null, 8, ["selected", "options"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.ownerId.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_67, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ])
    ])
  ], 64))
}
}

})